/************
 Product Size Chart
 ************/

const productSizeChartDialog = document.querySelector("#productSizeChartDialog");

function updateSizeChartStickyTableHeader(e) {
    const scrollContainer = document.querySelector("#productSizeChartDialogInner");
    const tableWrapper = document.querySelector(".productSizeChartDialogTableWrapper");
    const tableHeader = document.querySelector(".productSizeChartDialogTable thead");

    const OFFSET = -28; // The combined margin and padding in px

    const wrapperOffsetTop = tableWrapper.offsetTop;
    const scrollTop = scrollContainer.scrollTop;
    const headerHeight = tableHeader.offsetHeight;
    const wrapperHeight = tableWrapper.offsetHeight;

    // Adjusted range accounting for 20px margin at top and bottom
    const startSticky = wrapperOffsetTop - OFFSET;
    const stopSticky = wrapperOffsetTop + wrapperHeight - headerHeight - OFFSET;

    if (scrollTop >= startSticky && scrollTop <= stopSticky) {
        // Stick the header with the offset
        const translateY = scrollTop - wrapperOffsetTop + OFFSET;
        tableHeader.style.transform = `translateY(${translateY}px)`;
    } else if (scrollTop > stopSticky) {
        // Stop at the bottom of the wrapper minus offset
        const maxTranslate = wrapperHeight - headerHeight;
        tableHeader.style.transform = `translateY(${maxTranslate}px)`;
    } else {
        // Reset before it reaches the sticky point
        tableHeader.style.transform = `translateY(0px)`;
    }
}

// Dialog Scroll listener to update sticky table header
productSizeChartDialog.querySelector("#productSizeChartDialogInner").addEventListener("scroll", updateSizeChartStickyTableHeader);

document.querySelector(".productOptionGeneralSizeButton")?.addEventListener("click", function () {
    // open dialog
    productSizeChartDialog.showModal();
    document.body.classList.add("noScroll");
});

// close size chart dialog on close button click
document.querySelector("#productSizeChartDialogHeaderCloseButton")?.addEventListener("click", function () {
    document.querySelector("#productSizeChartDialog").close();
    document.body.classList.remove("noScroll");
});

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input, #product select").forEach(function (element) {
    element.addEventListener("change", function (e) {
        updateProduct(e);
    });
});

/**************
 Product Availability
 ***************/

function updateSizeAvailability() {
    // If the product does not have a size option, return early
    if (!product.options.includes("Size")) {
        return;
    }

    // Get all selected options minus the size and color option
    const selectedOptions = Array.from(document.querySelectorAll("#productOption input:checked"))
        .filter(input => input.name !== "Size" && input.name !== "Color") // Exclude size and color options
        .map(input => input.value);

    // Get the index of the size option
    const sizeIndex = product.options.findIndex(option => option === "Size");

    // Get the index of the color option
    const colorIndex = product.options.findIndex(option => option === "Color");

    // Find variants that match the selected options, excluding the size and color options, and are not available
    const unavailableVariants = product.variants.filter(variant => {
        return variant.options
            .filter((option, index) => index !== sizeIndex && index !== colorIndex) // Exclude the size option and color option
            .every(option => selectedOptions.includes(option)) && !variant.available; // Ensure the variant is not available
    });

    // Remove the "unavailable" class from all size inputs
    document.querySelectorAll("#productOption input[name='Size']").forEach(input => {
        input.parentElement.classList.remove("unavailable");
    });

    // Get all size inputs
    for (const unavailableVariant of unavailableVariants) {
        // Find the corresponding size input
        const sizeInput = document.querySelector(`#productOption input[name="Size"][value="${unavailableVariant.options[sizeIndex]}"]`);

        // If the size input exists, add the "unavailable" class to its parent element
        if (sizeInput) {
            sizeInput.parentElement.classList.add("unavailable");
        }
    }
}

function updateWidthAvailability() {
    // If the product does not have a width option, return early
    if (!product.options.includes("Width")) {
        return;
    }

    // Create an object to track available widths
    const availableWidths = {};

    // Get the index of the width option
    const widthIndex = product.options.findIndex(option => option === "Width");

    // Iterate through all variants to count available widths
    for (const variant of product.variants) {
        const width = variant.options[widthIndex];

        if (!availableWidths[width]) {
            // Initialize the width count if it doesn't exist
            availableWidths[width] = 0;
        }

        // Increment the count for this width if the variant is available
        if (variant.available) {
            availableWidths[width]++;
        }
    }

    for (const [key, value] of Object.entries(availableWidths)) {
        // Find the width input element and toggle the "unavailable" class based on the availability. A width is considered unavailable if all the variants with that width are not available.
        document.querySelector(`input[name="Width"][value="${key}"]`).parentElement.classList.toggle("unavailable", value === 0);
    }
}


/**************
 Product Visual
 ***************/

// update active variant
function updateProduct(e) {
    // collect options from inputs
    let options = [];
    document.querySelectorAll("#productOption [name]").forEach(function (element) {
        // if it's an input, it must be checked
        if (element.tagName === "INPUT" && !element.checked) {
            return;
        }

        options.push(element.value.toLowerCase());
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options.map(option => option.toLowerCase())) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    updateSizeAvailability();
    updateWidthAvailability();

    // dispatch variant change event
    document.dispatchEvent(new CustomEvent("activeVariantChange"));

    // update product option selection label
    const productOptionSelectionLabel = document.querySelector(`.productOptionGeneralLabel[data-option="${e?.target.name}"] .productOptionGeneralLabelSelection`);
    if (productOptionSelectionLabel) {
        productOptionSelectionLabel.textContent = e.target.value;
    }

    // update price
    document.querySelector("#productPriceReal").textContent = price(activeVariant.price);
    const isSale = activeVariant.compare_at_price > activeVariant.price;
    if (isSale) {
        document.querySelector("#productPriceReal").classList.add("sale");
        document.querySelector("#productPriceCompare").textContent = price(activeVariant.compare_at_price);
    } else {
        document.querySelector("#productPriceReal").classList.remove("sale");
        document.querySelector("#productPriceCompare").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").classList.add("primary");
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productATC").classList.remove("primary");
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Sold Out";
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

/****************
 * Product Notify Me When Available
 */
document.addEventListener("DOMContentLoaded", initBIS)

function initBIS() {
    if (BIS.urlIsProductPage() === true) {
        BIS.popup.ready.then(function () {

            // Exit script if product has no sold out variants.
            if (BIS.popup.variants.length < 1) {
                return;
            }

            // Add active class to product out of stock
            if (!product.tags.includes("bis-hidden")) {
                document.querySelector("#productOutOfStock").classList.add("active");
            }

            // Build button that will be inserted in the product page.
            const button = document.querySelector(".productOutOfStockButton");
            button.setAttribute('id', 'BIS_trigger');
            button.setAttribute('type', 'button');
            button.setAttribute('class', 'productOutOfStockButton product-submit action-button submit');

            // Insert the button into the product page.
            BIS.inlineButtonAnchor = '#productOutOfStock';
            const anchor = document.querySelector(BIS.inlineButtonAnchor);
            anchor.insertAdjacentElement('beforeend', button);

            // Control button visibility
            let variantId;
            const originalDisplay = button.style.display;
            BIS.refreshInlineButton = function () {
                try {
                    const variant = BIS.detectVariant(BIS.popup);

                    if (variant && BIS.popup.variantIsUnavailable(variant)) {
                        variantId = variant.id;
                        button.style.display = originalDisplay;
                    } else {
                        button.style.display = 'none';
                    }
                } catch (e) {
                    console.log(e);
                }
            };

            BIS.refreshInlineButton()

            BIS.delayedRefreshInlineButton = function () {
                setTimeout(function () {
                    BIS.refreshInlineButton()
                }, 15)
            };

            // Refresh button visibility on document change.
            document.addEventListener('change', BIS.delayedRefreshInlineButton);

            // Select the variant in popup form.
            button.addEventListener('click', function () {
                BIS.popup.form.selectVariant(variantId);
            });
        });
    }
}

/****************
 * Product Quantity
 */

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // set atc items
    let items;

    // add loading animation
    this.classList.add("loading");

    // Set items to B2B items if dealer site
    items = [{
        quantity: quantity,
        id: activeVariant.id,
    }];

    // Add category property if present
    if (productCategory) {
        items[0].properties = {
            "Category": productCategory
        }
    }

    let formData = {
        items: items
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


updateProduct();